import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const nav = css`
  display: inline-flex;
  color: ${colors.gray.dark};
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.bold};
  height: 54px;
  align-items: center;
  border-bottom: 4px solid ${colors.gray.light};
  width: 100%;

  & > svg {
    width: ${fonts.size.small};
    height: ${fonts.size.small};
    margin: 0 10px 0 20px;
  }
`;
